import { useState } from "react"
import useSWRImmutable from "swr/immutable"

import { SUPPORT_REFER } from "../../../../../errors/errorMessages"
import { snackbar } from "../../../../../utils/general/generalUtils"
import { getClientProtected } from "../../../clients/clients"
import { dnoUserSuggestionMapper } from "../../../mappers/dnoInterface/dnoUserSuggestionMapper"
import { NO_REVALIDATE_CONFIG } from "../../../swrConfig"
import { IUsersType } from "../../../types/dnoInterface/dnoUserSuggestionTypes"
import { LIST_USER_SUGGESTIONS } from "../../../urls/private"

interface IUserSuggestionType {
    users: IUsersType | undefined
    isLoadingSuggestion: boolean
    getUserNameFromId: (name: string) => string
}

/**
 * Custom hook for retrieving usersID.
 * @returns An object containing the usersID function and isLoading flag.
 */
const useDnoUserSuggestion = (
    input: string | undefined,
    disabled = true
): IUserSuggestionType => {
    const [isLoadingSuggestion, setIsLoadingSuggestion] = useState(false)
    const { data } = useSWRImmutable(
        disabled ? LIST_USER_SUGGESTIONS(input) : null,
        async (url: string): Promise<IUsersType | undefined> => {
            try {
                setIsLoadingSuggestion(true)
                const res = await getClientProtected(url)
                const usersMapped =
                    dnoUserSuggestionMapper.mapUserSuggestion(res)
                return usersMapped
            } catch {
                snackbar(
                    `Unable to assign to user. Please try again. ${SUPPORT_REFER}`,
                    "warning"
                )
                return undefined
            } finally {
                setIsLoadingSuggestion(false)
            }
        },
        NO_REVALIDATE_CONFIG
    )

    const getUserNameFromId = (name: string): string => {
        const user: string | undefined = data?.find(
            (userName) => userName?.username === name
        )?.name
        return user || ""
    }

    return {
        users: data,
        isLoadingSuggestion,
        getUserNameFromId,
    }
}
export default useDnoUserSuggestion
